import React from "react"

export const RayBackground: React.FC = () => (
  <svg
    aria-hidden="true"
    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none" }}
    preserveAspectRatio="xMidYMid slice"
    viewBox="0 0 1440 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      {/* Fade mask — content fades out toward top */}
      <linearGradient id="fb-fade" x1="0" y1="1" x2="0" y2="0">
        <stop offset="0%"   stopColor="white" stopOpacity="1" />
        <stop offset="60%"  stopColor="white" stopOpacity="0.4" />
        <stop offset="100%" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <mask id="fb-mask">
        <rect x="0" y="0" width="1440" height="500" fill="url(#fb-fade)" />
      </mask>

      {/* Green tones */}
      <linearGradient id="fb-deep" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%"   stopColor="#166534" stopOpacity="0.12" />
        <stop offset="100%" stopColor="#166534" stopOpacity="0"    />
      </linearGradient>
      <linearGradient id="fb-mid" x1="1" y1="0" x2="0" y2="1">
        <stop offset="0%"   stopColor="#16a34a" stopOpacity="0.09" />
        <stop offset="100%" stopColor="#16a34a" stopOpacity="0"    />
      </linearGradient>
      <linearGradient id="fb-light" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%"   stopColor="#4ade80" stopOpacity="0.07" />
        <stop offset="100%" stopColor="#4ade80" stopOpacity="0"    />
      </linearGradient>
      <linearGradient id="fb-earth" x1="1" y1="1" x2="0" y2="0">
        <stop offset="0%"   stopColor="#92400e" stopOpacity="0.06" />
        <stop offset="100%" stopColor="#92400e" stopOpacity="0"    />
      </linearGradient>
      <linearGradient id="fb-amber" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0%"   stopColor="#d97706" stopOpacity="0.07" />
        <stop offset="100%" stopColor="#d97706" stopOpacity="0"    />
      </linearGradient>
    </defs>

    <g mask="url(#fb-mask)">

      {/* Large background organic blobs — land mass shapes */}
      <ellipse cx="200"  cy="480" rx="380" ry="200" fill="url(#fb-deep)"  />
      <ellipse cx="1260" cy="460" rx="320" ry="180" fill="url(#fb-deep)"  />
      <ellipse cx="720"  cy="500" rx="500" ry="160" fill="url(#fb-mid)"   />

      {/* Mid-layer field patches */}
      <ellipse cx="120"  cy="400" rx="200" ry="110" fill="url(#fb-mid)"   />
      <ellipse cx="480"  cy="440" rx="260" ry="120" fill="url(#fb-light)"  />
      <ellipse cx="960"  cy="430" rx="280" ry="130" fill="url(#fb-light)"  />
      <ellipse cx="1380" cy="390" rx="180" ry="100" fill="url(#fb-mid)"   />

      {/* Earth tones — soil patches bottom corners */}
      <ellipse cx="80"   cy="490" rx="160" ry="80"  fill="url(#fb-earth)" />
      <ellipse cx="1360" cy="490" rx="180" ry="90"  fill="url(#fb-earth)" />
      <ellipse cx="720"  cy="495" rx="220" ry="70"  fill="url(#fb-amber)" />

      {/* Leaf-like curved shapes using paths — top canopy */}
      <path
        d="M0,300 Q180,180 360,260 Q540,340 720,200 Q900,60 1080,180 Q1260,300 1440,220 L1440,500 L0,500 Z"
        fill="url(#fb-light)"
        opacity="0.5"
      />
      <path
        d="M0,380 Q200,300 440,350 Q680,400 720,320 Q760,240 1000,310 Q1240,380 1440,300 L1440,500 L0,500 Z"
        fill="url(#fb-mid)"
        opacity="0.4"
      />

      {/* Scattered leaf dots — tree canopy hints */}
      {[
        [140, 350], [310, 290], [530, 370], [680, 260],
        [820, 310], [1010, 280], [1150, 350], [1320, 300],
        [240, 420], [760, 400], [1100, 410],
      ].map(([cx, cy], i) => (
        <ellipse
          key={i}
          cx={cx} cy={cy}
          rx={28 + (i % 3) * 10}
          ry={16 + (i % 4) * 6}
          fill="url(#fb-deep)"
          opacity={0.4 + (i % 3) * 0.15}
          transform={`rotate(${-20 + (i * 17) % 40}, ${cx}, ${cy})`}
        />
      ))}

      {/* Fine contour lines — topographic feel */}
      <path
        d="M0,420 Q360,380 720,400 Q1080,420 1440,390"
        fill="none" stroke="#16a34a" strokeOpacity="0.06" strokeWidth="1.5"
      />
      <path
        d="M0,450 Q300,420 600,440 Q900,460 1200,430 Q1320,420 1440,445"
        fill="none" stroke="#166534" strokeOpacity="0.05" strokeWidth="1"
      />
      <path
        d="M0,470 Q400,455 720,465 Q1040,475 1440,460"
        fill="none" stroke="#16a34a" strokeOpacity="0.04" strokeWidth="1"
      />
    </g>
  </svg>
)

export default RayBackground